export type CompanyType = 
  | 'CLIENT'
  | 'EPC'
  | 'EP'
  | 'PMC'
  | 'QC'
  | 'CONSTRUCTION'
//   | 'ERECTION'
  | 'SUPPLIER'
  | 'ENGINEERING'
//   | 'ELECTRICAL'
//   | 'CONTROL_INSTRUMENTATION'
//   | 'UTILITY'
//   | 'SUB_CONTRACTOR'
  | 'OTHER'
;

export const COMPANY_TYPE_OPTIONS: { value: CompanyType; label: string }[] = [
    { value: 'EPC', label: 'EPC' },
    { value: 'EP', label: 'EP' },
    { value: 'PMC', label: 'PMC' },
    { value: 'QC', label: 'QC' },
    { value: 'CONSTRUCTION', label: 'Construction' },
    { value: 'SUPPLIER', label: 'Supplier' },
    { value: 'ENGINEERING', label: 'Engineering' },
    { value: 'CLIENT', label: 'Client' },
    { value: 'OTHER', label: 'Other' },
];

export type ProjectCompanyRole = 
  | 'INTERNAL'
  | 'CLIENT'
  | 'EPC'
  | 'EP'
  | 'PMC'
  | 'QC'
  | 'CONSTRUCTION'
  | 'ERECTION'
  | 'SUPPLIER'
  | 'ENGINEERING'
  | 'ELECTRICAL'
  | 'CONTROL_INSTRUMENTATION'
  | 'UTILITY'
  | 'SUB_CONTRACTOR'
  | 'OTHER'
;

export const PROJECT_COMPANY_ROLE_OPTIONS: { value: ProjectCompanyRole; label: string }[] = [
    { value: 'INTERNAL', label: '내부 조직'},
    { value: 'CLIENT', label: 'Client (발주처)' },
    { value: 'EPC', label: 'EPC Contractor' },
    { value: 'EP', label: 'EP Contractor' },
    { value: 'PMC', label: 'PMC' },
    { value: 'QC', label: 'QC' },
    { value: 'CONSTRUCTION', label: 'Construction' },
    { value: 'ERECTION', label: 'Erection' },
    { value: 'SUPPLIER', label: 'Supplier' },
    { value: 'ENGINEERING', label: 'Engineering & Design' },
    { value: 'ELECTRICAL', label: 'Electrical' },
    { value: 'CONTROL_INSTRUMENTATION', label: 'Control & Instrumentation' },
    { value: 'UTILITY', label: 'Utility' },
    { value: 'SUB_CONTRACTOR', label: 'Subcontractor' },
    { value: 'OTHER', label: 'Other' },
];
